var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"title":"Confirm","ok-title":"Yes","cancel-title":"No","ok-variant":"outline-success","cancel-variant":"outline-danger","hide-header-close":""},on:{"ok":_vm.confirm,"cancel":_vm.cancel},model:{value:(_vm.showModal),callback:function ($$v) {_vm.showModal=$$v},expression:"showModal"}},[_vm._v(" "+_vm._s(_vm.message)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }